<template>
  <Card header="Download a report now">
    <GenerateReport v-if="$store.getters['generatePDF']"></GenerateReport>
    <img src="/static/report/get_report.svg" alt="get report image" />
    <button class="btn btn-primary" @click="onClick()">Download report</button>
  </Card>
</template>

<script>
import Card from './index';
import GenerateReport from '../GenerateReport';
export default {
  components: { Card, GenerateReport },
  methods: {
    onClick() {
      this.$store.dispatch('startDownloadPDF');
    }
  }
};
</script>

<style lang="scss" scoped></style>
